import { USER_MANAGEMENT_DEFAULTS as D } from '../UserManagement.constants'

export type Assignment = {
    customerId: string
    roleLabel: string
}

const CUSTOMER_RESTRICTED_TOKENS = new Set(['customeruser', 'customermanager'])

function isCustomerRestrictedRole(roleLabel: string): boolean {
    const normalized = roleLabel.toLowerCase().replace(/[\s_-]/g, '')
    return CUSTOMER_RESTRICTED_TOKENS.has(normalized)
}

export type ValidateAssignmentOptions = {
    customerId: string
    roleLabel: string
    hideProductDropdown: boolean
    selectedProducts: string[]
    existingAssignments: Assignment[]
    restrictedRoleMessage?: string
}

export function validateAssignment({
    customerId,
    roleLabel,
    hideProductDropdown,
    selectedProducts,
    existingAssignments,
    restrictedRoleMessage,
}: ValidateAssignmentOptions): string {
    if (!hideProductDropdown && selectedProducts.length === 0) return ''

    if (isCustomerRestrictedRole(roleLabel) && existingAssignments.length > 0) {
        return restrictedRoleMessage || D.VALIDATION_SINGLE_ACCOUNT_ROLE
    }

    if (existingAssignments.some(a => isCustomerRestrictedRole(a.roleLabel))) {
        return restrictedRoleMessage || D.VALIDATION_SINGLE_ACCOUNT_ROLE
    }

    if (existingAssignments.some(a => a.customerId === customerId)) {
        return D.VALIDATION_DUPLICATE_ACCOUNT
    }

    return ''
}
